import { render, staticRenderFns } from "./upload-audio.vue?vue&type=template&id=5a8da840&scoped=true&"
import script from "./upload-audio.vue?vue&type=script&lang=js&"
export * from "./upload-audio.vue?vue&type=script&lang=js&"
import style0 from "./upload-audio.vue?vue&type=style&index=0&id=5a8da840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8da840",
  null
  
)

export default component.exports